import React from "react";
import { Modal } from "antd";
import { getToken } from "pages/myutils/user";
import Form from "./index";
import "../../index.css";

const AddClerk = ({ visible, onClose, title, companyId, user }) => {
  const [role, token] = getToken();
  return (
    <Modal
      title={title}
      visible={visible}
      footer={null}
      onCancel={onClose}
      width={1000}
    >
      <div style={{ height: "calc(100vh - 300px)", overflow: "auto" }}>
        <Form
          title={title}
          companyIds={companyId}
          tokens={token}
          onClose={onClose}
          user={user}
        />
      </div>
    </Modal>
  );
};

export default AddClerk;
